import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Form, Input, Modal} from 'antd';
import {addClientApp} from '@/api/clientApps';

const ClientAppFormModal = forwardRef(({reload}, ref) => {
    const formRef = useRef();

    const [visible, setVisible] = useState(false);

    function showModal() {
        setVisible(true);
    }

    function closeModal() {
        setVisible(false);
    }

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));

    function onOk() {
        formRef.current.submit();
    }

    function onFinish(values) {
        console.log('Received values of form: ', values);

        addClientApp(values).then(data => {
            console.log(data);
            reload();
            closeModal();
        });
    }

    return (
        <Modal
            destroyOnClose
            maskClosable={false}
            visible={visible}
            title="添加 Api 群组"
            onCancel={closeModal}
            onOk={onOk}
        >
            <Form ref={formRef} onFinish={onFinish} layout="vertical">
                <Form.Item hidden name="id">
                    <Input />
                </Form.Item>

                <Form.Item
                    name="name"
                    label="Api 群组名称"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input placeholder="Api 群组名称" autoFocus maxLength={30} />
                </Form.Item>
                <Form.Item name="description" label="说明">
                    <Input placeholder="说明" maxLength={100} />
                </Form.Item>

                <Form.Item style={{display: 'none'}}>
                    <Button type="primary" htmlType="submit" />
                </Form.Item>
            </Form>
        </Modal>
    );
});

ClientAppFormModal.displayName = 'ClientAppFormModal';

ClientAppFormModal.propTypes = {
    reload: PropTypes.func.isRequired,
};

export default ClientAppFormModal;
